import { createSignal } from '@verclam/pulsar';

export type ContactSidebarContext = {
	readonly contactId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the contact carried by `contactId`; a `contactId`
 * of `null` inside an open context creates one instead.
 */
const contactSidebarSignal = createSignal<ContactSidebarContext | null>(null);

export const openContactSidebar = (contactId: number | null = null): void => {
	contactSidebarSignal.value = { contactId };
};

export const closeContactSidebar = (): void => {
	contactSidebarSignal.value = null;
};

export default contactSidebarSignal;
